<template>
  <div class="col-span-2 sm:col-span-2">
    <div class="relative">
      <div class="absolute inset-0 flex items-center" aria-hidden="true">
        <div class="w-full border-t border-gray-300" />
      </div>
      <div class="relative flex justify-start">
        <span class="pr-3 bg-light-grey text-lg font-medium text-vice-teal-700">Past sessions</span>
      </div>
    </div>

    <div class="flex flex-col mt-8" v-if="pastSessionsExist">
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <vice-table :tableData="tidyTableData"></vice-table>
        </div>
      </div>
    </div>

    <div class="mt-8 text-gray-500 text-center" v-else>
      Sessions in which you participated will appear here.
    </div>
  </div>
</template>

<script>
import DateFormatMixin from '@/Mixins/DateFormatMixin.vue';
import ViceTable from '@/Components/Tables/ViceTable.vue';

export default {
  name: 'PastSessions',
  setup() {
    return {
      userType,
    };
  },
  components: {
    ViceTable,
  },
  mixins: [DateFormatMixin],
  computed: {
    pastSessionsExist() {
      return Object.keys(this.$page.props.sessions.past_sessions).length;
    },
    tidyTableData() {
      const filteredRowsData = Object.values(this.$page.props.sessions.past_sessions).map((row) => [
        { slug: 'title', name: 'Title', data: row.session.title },
        {
          slug: 'sessionStart',
          name: 'Started on',
          data: `${this.yearFormatter(
            row.session.details.session_start_by_timezone,
          )} ${this.hoursFormatter(row.session.details.session_start_by_timezone)}`,
        },
        {
          slug: 'sessionEnd',
          name: 'Ended',
          data: `${this.yearFormatter(
            row.session.details.session_end_by_timezone,
          )} ${this.hoursFormatter(row.session.details.session_end_by_timezone)}`,
        },
        { slug: 'clinician', name: 'Clinician', data: row.session.details.clinician?.name },
        { slug: 'uniqueId', name: '', data: row.session.unique_id, type: 'url' },
      ]);
      return filteredRowsData;
    },
  },
};
</script>
